import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translations } from './data';
import intervalPlural from 'i18next-intervalplural-postprocessor';

i18next.use(intervalPlural);
i18next.use(LanguageDetector).init({
  // we init with resources
  resources: translations,
  fallbackLng: 'template',
  // debug: process.env.NODE_ENV === 'development' ? true : false,
  debug: false, // TODO вернуть верхнюю строку

  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // we use content as keys

  interpolation: {
    formatSeparator: ',',
  },

  react: {
    wait: true,
  },
});

i18next.changeLanguage('template');

export default i18next;
